if (!customElements.get('product-peek-carousel')) {
  class ProductPeekCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.progress = this.querySelector('[data-carousel-progress]');
      this.progressThumb = this.querySelector('[data-carousel-progress-thumb]');
      this.slider = this.closest('.product-media__slider');

      if (!this.track || !this.progress || !this.progressThumb) return;

      this.animationFrame = null;
      this.resetFrame = null;
      this.revealFrame = null;
      this.handleScroll = this.scheduleUpdate.bind(this);
      this.handleResize = this.scheduleUpdate.bind(this);
      this.handleMutations = this.onTrackMutations.bind(this);
      this.handlePageShow = this.revealFromFirstSlide.bind(this);

      this.track.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize, { passive: true });
      window.addEventListener('pageshow', this.handlePageShow);

      if (typeof ResizeObserver === 'function') {
        this.resizeObserver = new ResizeObserver(this.handleResize);
        this.resizeObserver.observe(this.track);
      }

      this.mutationObserver = new MutationObserver(this.handleMutations);
      this.mutationObserver.observe(this.track, { childList: true });
      this.observeImages();
      this.resetToFirstSlide();

      if (document.readyState === 'complete') this.revealFromFirstSlide();
    }

    disconnectedCallback() {
      if (!this.track) return;

      this.track.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
      window.removeEventListener('pageshow', this.handlePageShow);
      this.resizeObserver?.disconnect();
      this.mutationObserver?.disconnect();
      window.cancelAnimationFrame(this.animationFrame);
      window.cancelAnimationFrame(this.resetFrame);
      window.cancelAnimationFrame(this.revealFrame);
    }

    onTrackMutations() {
      this.observeImages();
      this.resetToFirstSlide();
    }

    resetToFirstSlide() {
      this.track.scrollLeft = 0;
      window.cancelAnimationFrame(this.resetFrame);
      this.resetFrame = window.requestAnimationFrame(() => {
        this.track.scrollLeft = 0;
        this.updateProgress();
      });
    }

    revealFromFirstSlide() {
      this.resetToFirstSlide();
      window.cancelAnimationFrame(this.revealFrame);
      this.revealFrame = window.requestAnimationFrame(() => {
        this.track.scrollLeft = 0;
        this.updateProgress();
        if (this.slider) this.slider.style.opacity = '1';
      });
    }

    observeImages() {
      this.track.querySelectorAll('img').forEach((image) => {
        if (!image.complete) image.addEventListener('load', this.handleResize, { once: true });
      });
    }

    scheduleUpdate() {
      window.cancelAnimationFrame(this.animationFrame);
      this.animationFrame = window.requestAnimationFrame(() => this.updateProgress());
    }

    updateProgress() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const viewportRatio = this.track.scrollWidth > 0 ? this.track.clientWidth / this.track.scrollWidth : 1;
      const thumbWidth = Math.min(100, viewportRatio * 100);
      const scrollPercent = maxScroll > 0 ? Math.min(1, Math.max(0, this.track.scrollLeft / maxScroll)) : 0;

      this.progressThumb.style.width = `${thumbWidth}%`;
      this.progressThumb.style.left = `${scrollPercent * (100 - thumbWidth)}%`;
      this.progress.setAttribute('aria-valuenow', String(Math.round(scrollPercent * 100)));
    }
  }

  customElements.define('product-peek-carousel', ProductPeekCarousel);
}
